"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/ADFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_3)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_3`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H6V24H-6V0Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M18 0H30V24H18V0ZM7.95789 7.97193H11.9649V12.5193H7.95789V7.97193Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12.7789 7.97192V12.5123V7.97192ZM13.9438 7.97192V12.5123V7.97192ZM15.1088 7.97192V12.5123V7.97192Z",
					fill: "black"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12.7789 7.97192V12.5123M13.9438 7.97192V12.5123M15.1088 7.97192V12.5123",
					stroke: "#D80027",
					strokeWidth: .491228
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.3614 12.5193V17.0596V12.5193ZM10.4281 12.5193V17.0596V12.5193ZM9.49473 12.5263V16.3088V12.5263ZM8.53333 12.5263V15.8316V12.5263Z",
					fill: "black"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.3614 12.5193V17.0596M10.4281 12.5193V17.0596M9.49473 12.5263V16.3088M8.53333 12.5263V15.8316",
					stroke: "#D80027",
					strokeWidth: .350877
				}),
				/* @__PURE__ */ n("path", {
					d: "M8.02808 10.2456L9.96492 7.97192L11.9649 10.2386L9.99299 12.5123L8.02808 10.2456Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M6.78595 6.72986V13.2C6.78595 15.6071 8.70174 17.0035 10.1965 17.7264C10.1403 17.8246 11.9579 18.3088 11.9579 18.3088C11.9579 18.3088 13.7754 17.8246 13.7193 17.7264C15.221 17.0035 17.1298 15.6141 17.1298 13.2V6.72986H6.78595ZM15.9017 13.2C15.9017 14.386 15.2 15.2632 13.6 16.2807C12.9965 16.6667 12.3719 16.9123 11.9649 17.0527C11.5579 16.9123 10.9333 16.6667 10.3298 16.2807C8.72981 15.2632 8.02805 14.3158 8.02805 13.2V7.97196H15.9017V13.2Z",
					fill: "#BC8B00"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12.5544 13.2561H14.6246V13.8596H12.5544V13.2561ZM12.5544 14.4912H14.6246V15.0947H12.5544V14.4912Z",
					fill: "#D80027"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_3`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as ADFlag };
